<h2>Placards <button class="icon--history btn--default" type="button" (click)="showHistory()">View History</button></h2>
<p-table #dt [value]="placardDisplayInfo">
    <ng-template pTemplate="header">
        <tr>
            <th>Placard Number</th>
            <th>Type</th>
            <th>Issue Date</th>
            <th>Expiration Date</th>
            <th>Status</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="5">
                No records found
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
        <tr [pSelectableRow]="rowData">
            <td>{{rowData.placardNumber}}</td>
            <td>{{rowData.placardType}}</td>
            <td>{{rowData.placardStatusChangeDate | shortDate}}</td>
            <td>{{rowData.placardExpirationDate | shortDate}}</td>
            <td>{{rowData.placardStatus}}</td>
        </tr>
    </ng-template>
</p-table>